import { render, staticRenderFns } from "./UptraceQuery.vue?vue&type=template&id=2d8ca0c7&scoped=true&"
import script from "./UptraceQuery.vue?vue&type=script&lang=ts&"
export * from "./UptraceQuery.vue?vue&type=script&lang=ts&"
import style0 from "./UptraceQuery.vue?vue&type=style&index=0&id=2d8ca0c7&prod&lang=scss&scoped=true&"
import style1 from "./UptraceQuery.vue?vue&type=style&index=1&id=2d8ca0c7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.7.3_vue-template-compiler@2.7.15_webpack@5.80.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8ca0c7",
  null
  
)

export default component.exports